export default __webpack_public_path__ + "static/media/arrw.baeec967.svg";